import { posterType } from 'json/index'
// 表格表头
export let tableLabels = [
  {
    label: '海报名称',
    value: 'name'
  },
  {
    label: '适用商品',
    value: 'goodsName'
  },
  {
    label: '海报类型',
    value: 'poster_type'
  },
  {
    label: '海报状态',
    value: 'status_copy'
  },
  {
    label: '发布时间',
    value: 'publishTime_copy'
  },
  {
    label: '创建时间',
    value: 'createTime_copy'
  }
]
// 选择商品的列表顶部筛选
export let filterItems = [
  {
    label: '发布时间',
    type: 'time-slot',
    value: 'publishTime',
    startName: 'publishStart',
    endName: 'publishEnd'
  }, {
    label: '海报类型',
    type: 'select',
    clearable: true,
    value: 'type', // 需返回数据的字段名
    options: posterType
  }
]
